import React,{useState} from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import {useAuth} from '../../context/AuthContext';
import AuthLayout,{AuthField,AuthError,authInputClass,TEXT_SHADOW} from './AuthLayout';

const {FiMail,FiLock,FiArrowRight}=FiIcons;

// En desarrollo (npm run dev) se rellena el admin local de .env.development.local; en producción esto se elimina del build.
const DEV_LOGIN=import.meta.env.DEV
  ? {email: import.meta.env.VITE_DEV_LOGIN_EMAIL || '',password: import.meta.env.VITE_DEV_LOGIN_PASSWORD || ''}
  : {email: '',password: ''};

export default function Login({onShowRegister}) {
  const [email,setEmail]=useState(DEV_LOGIN.email);
  const [password,setPassword]=useState(DEV_LOGIN.password);
  const [error,setError]=useState('');
  const [submitting,setSubmitting]=useState(false);
  const {login,guestLogin}=useAuth();

  const handleSubmit=async (e)=> {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await login(email,password);
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  const handleGuest=async ()=> {
    setError('');
    setSubmitting(true);
    try {
      await guestLogin();
    } catch (err) {
      setError(err.message);
      setSubmitting(false);
    }
  };

  return (
    <AuthLayout
      subtitle="Identifícate para continuar"
    >
      <form onSubmit={handleSubmit} className="space-y-6">
        <AuthField label="Email" icon={FiMail}>
          <input type="email" required autoComplete="email" value={email} onChange={(e)=> setEmail(e.target.value)} className={authInputClass()} placeholder="ejemplo@dojang.com" />
        </AuthField>
        <AuthField label="Contraseña" icon={FiLock}>
          <input type="password" required autoComplete="current-password" value={password} onChange={(e)=> setPassword(e.target.value)} className={authInputClass()} placeholder="••••••••" />
        </AuthField>
        <AuthError message={error} />
        <button type="submit" disabled={submitting} className="w-full bg-red-600 hover:bg-red-500 disabled:opacity-60 text-white py-5 rounded-2xl font-black uppercase tracking-[0.3em] text-[10px] transition-all shadow-xl shadow-red-600/20 active:scale-95 flex items-center justify-center gap-2">
          {submitting ? 'Entrando...' : 'Entrar al Dojang'} <SafeIcon icon={FiArrowRight} />
        </button>
        <div className="flex items-center gap-4 pt-2">
          <div className="h-px flex-1 bg-white/30" />
          <span className="text-white text-[10px] font-black uppercase tracking-[0.3em] [text-shadow:_0_1px_6px_rgba(0,0,0,0.9)]">¿Aún no tienes cuenta?</span>
          <div className="h-px flex-1 bg-white/30" />
        </div>
        <button type="button" onClick={onShowRegister} disabled={submitting} className="w-full bg-white text-zinc-900 hover:bg-zinc-200 disabled:opacity-60 py-4 rounded-2xl font-black uppercase tracking-[0.3em] text-[11px] transition-all shadow-xl active:scale-95">
          Soy alumno: crear mi cuenta
        </button>
        <button type="button" onClick={handleGuest} disabled={submitting} className="w-full bg-black/40 border border-white/40 hover:bg-black/55 hover:border-white disabled:opacity-60 text-white py-4 rounded-2xl font-black uppercase tracking-[0.3em] text-[11px] transition-all active:scale-95">
          Entrar como invitado
        </button>
        <p className="text-center text-white text-xs font-semibold leading-relaxed [text-shadow:_0_1px_6px_rgba(0,0,0,0.9)]">
          Para padres de familia y visitantes: consulta eventos, videos y practica sin cuenta.
        </p>
      </form>
    </AuthLayout>
  );
}
